import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/partner')({
  beforeLoad: authorizedRouteLoader('partner'),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page
      links={[
        { label: 'Mapping', to: '/partner/mapping' },
        { label: 'Targets', to: '/partner/targets' },
      ]}
      title="Partner Delivery"
    />
  );
}
